module.exports = __webpack_public_path__ + "static/ch-him2-lp-quiz-2-9798dd083609fa90b7d0f3b56e876b4b.jpg";